import React from 'react';
import type { CMSProps, GQLProps } from 'Cms/product-price-ticket/resolver';
import { addTranslationKeys } from 'Src/i18n';
import { PriceTicket } from 'Components/widgets/price-ticket/PriceTicket';
const DATE_FORMAT = 'D MMMM YYYY';
type Props = CMSProps & GQLProps;
export const ProductPriceTicketLine = ({
  adult,
  adults,
  askForQuotation,
  book,
  collapseLabels,
  condensedDepartureDateFormat,
  config,
  cruise,
  departureCityLabel,
  departureDateFormat = DATE_FORMAT,
  departureDateLabel,
  durationPlaceholder,
  fromToPlaceholder,
  product,
  seeAllPrices,
  startingPriceCriteriaLabel,
}: Props) => {
  if (!product) {
    return null;
  }

  const { travelAdvisor, ...i18nConfig } = config;
  addTranslationKeys({
    ...i18nConfig,
    productPriceTicketLine: {
      adult,
      adults,
      askForQuotation,
      book,
      collapseLabels,
      condensedDepartureDateFormat,
      departureCityLabel,
      departureDateFormat,
      departureDateLabel,
      durationPlaceholder,
      fromToPlaceholder,
      seeAllPrices,
      startingPriceCriteriaLabel,
    },
  });
  return (
    <div className="Line Line-PriceTicket relative z-3" data-testid="Line-ProductPriceTicket">
      <PriceTicket cruise={cruise} product={product} travelAdvisorConfig={travelAdvisor} />
    </div>
  );
};
